import React from "react";
import { useLocation } from "react-router-dom";

import GLPCommonComponentModal from "./GLPCommonComponentModal";

import { URL_TEACHER_LOGIN } from "Helpers";
import { GLPCommonComponentWrapper } from "./GLPCommonComponentStyle";

function TeacherPage(props) {
	const location = useLocation();

	const SubscriptionDetails = location?.state?.subscriptionRequestDto;

	return (
		<GLPCommonComponentWrapper>
			<GLPCommonComponentModal subscriptionDetails={SubscriptionDetails} renderProps={location?.pathname === URL_TEACHER_LOGIN ? "teacher-login" : "school-register"} />
		</GLPCommonComponentWrapper>
	);
}

export default TeacherPage;
